import React from 'react';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';
import useEventStyle from '@hooks/CachedLists/UseEventStyle';

import AddressLine from '@components/Addresses/AddressLine';
import VerticalPeriod from '@components/Dates/VerticalPeriod';
import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon from '@components/Gui/NwIcon';
import ResponsiveFlexContainer from '@components/Gui/ResponsiveFlexContainer';

const EventFieldsTable = styled.div`
    width: 100%;
    .icon-container {
        padding-right: 1rem;
        svg {
            font-size: 2.4rem;
            margin: 0 0 8px;
        }
    }
    .arrow-dropdown {
        font-size: 0.95rem;
        margin: 4px 0;
    }
    .label {
        font-size: 0.65rem;
    }
    .date {
        font-size: 0.8rem;
        font-weight: bold;
    }

    &:first-child {
        padding-left: 0;
        flex: unset;
    }
    &:last-child {
        border-right: none;
    }
`;

const MeetingDetails = ({ meetingsData }) => {
    const meetingStyle = useEventStyle({}, 'Meeting');

    return (
        <FlexContainer pd="16px 30px 16px 40px">
            <EventFieldsTable>
                <ResponsiveFlexContainer
                    columns={[
                        {
                            content: (
                                <div className="is-icon">
                                    <NwIcon icon={meetingStyle.icon} />
                                </div>
                            ),
                            isBorder: true,
                            width: '30%',
                        },
                        {
                            content: (
                                <>
                                    <div className="is-content is-stronger big">
                                        w/ {getContactName(meetingsData.ContactID)}
                                    </div>
                                    <br />
                                    <div className="is-content">
                                        <AddressLine address={meetingsData} twoLines noIcon />
                                    </div>
                                </>
                            ),
                            isBorder: true,
                            width: '40%',
                        },
                        {
                            content: (
                                <VerticalPeriod
                                    startDate={meetingsData.StartDate}
                                    endDate={meetingsData.EndDate}
                                    time
                                />
                            ),
                            isBorder: false,
                            width: '30%',
                        },
                    ]}
                />
            </EventFieldsTable>
        </FlexContainer>
    );
};

export default MeetingDetails;
